import React, { useContext } from 'react';
import { useSelector } from 'react-redux';
import { PPSI } from '@ikea-food-ux/ppsi';
import { getMarketOverviewLabels } from '../../../features/app/overviewLabelSelectors';
import { getMarketProductions } from '../../../features/app/productionSelectors';
import { getMarketStockHierarchy } from '../../../features/app/stockHierarchySelectors';
import { getMarketTemperatureUnits } from '../../../features/app/temperatureUnitSelectors';
import { getMarketTimeUnits } from '../../../features/app/timeUnitSelectors';
// import { getIngredientEntriesByIds } from '../../../features/IngredientEntryContainer/selectors';
import {
  getMarketPpiDataForIds,
  getMarketPpisAll
} from '../../../features/PpiContainer/selectors';
import { getMarketUtensils } from '../../../features/UtensilContainer/selectors';
import {
  getMarketLanguage,
  getMarketConfig
} from '../../../features/app/selectors';
import { stitchPpis } from '../../../utils/ui2pStitchPPI';
import stichPpsi from '../../../utils/ui2pStitchPPSI';
import FormContext from '../../Form/FormContext';
import { getShelfLifeTimeUnitsUnits } from 'features/app/shelfLifeTimeUnitsSelectors';
import { getIsGlobalUser } from 'features/loginSystem/selectors';

function getPpiDataIdsFromPpiDetails(ppiDetails = []) {
  return ppiDetails
    .filter(ppiDetail => ppiDetail.ppiEnrichmentDataId)
    .map(ppiDetail => ppiDetail.ppiEnrichmentDataId);
}

const MarketOverviewTab = () => {
  const { data } = useContext(FormContext);
  const { referencedIFoodData, ppiDetails } = data;

  const ingredientEntries = referencedIFoodData.referencedIngredientEntities.sort(
    (a, b) => a.lineId - b.lineId
  );

  const usedPpiIds = ppiDetails && ppiDetails.map(i => i.ppiEnrichmentDataId);

  const ppiDataList = useSelector(getMarketPpisAll).toJS();
  const localMarket = JSON.parse(localStorage.getItem('localMarket'));
  // const language = useSelector(getLanguage);
  const language = useSelector(getMarketLanguage);
  const unitSystem = useSelector(getMarketConfig).toJS().ifoodPPSIUnitSystem;
  const labels = useSelector(getMarketOverviewLabels).toJS();
  const timeUnits = useSelector(getMarketTimeUnits).toJS();
  const temperatureUnits = useSelector(getMarketTemperatureUnits).toJS();
  const stockHierarchy = useSelector(getMarketStockHierarchy).toJS();
  const productionOptions = useSelector(getMarketProductions).toJS();
  const utensils = useSelector(getMarketUtensils).toJS();
  let shelfLifeTimeUnits = useSelector(getShelfLifeTimeUnitsUnits).toJS();
  const isGlobalUser = useSelector(getIsGlobalUser);
  const ppiDataLists =
    ppiDataList && ppiDataList.map(i => i.publishedPPIEnrichmentData);

  const finalPpiDataList = ppiDataLists.filter(
    i => i !== null && usedPpiIds.includes(i.id)
  );

  const ppis = stitchPpis(finalPpiDataList);
  const ppsi = stichPpsi(data, ppis, ingredientEntries, language);

  const getExcludedItemCodes =
    ppiDetails &&
    ppiDetails.filter(i => i.ppiNotRequired === true).map(i => i.itemCode);

  const ppiWithoutExcludeData =
    ppsi &&
    ppsi.ppiDetails.filter(i => !getExcludedItemCodes.includes(i.itemCode));

  const finalPpsi = { ...ppsi, ppiDetails: ppiWithoutExcludeData };
  if (isGlobalUser) {
    shelfLifeTimeUnits = shelfLifeTimeUnits.map(a => ({
      ...a,
      info: { ...a.info, [language]: a.info['EN-IF'] }
    }));
  }
  return (
    <PPSI
      ppsi={finalPpsi}
      labels={labels}
      timeUnits={timeUnits}
      temperatureUnits={temperatureUnits}
      stockHierarchy={stockHierarchy}
      productionOptions={productionOptions}
      utensils={utensils}
      language={language}
      navigateIcon="none"
      unitSystem={unitSystem}
      shelfLifeTimeUnits={shelfLifeTimeUnits}
    />
  );
};

export default MarketOverviewTab;
